<template>
	<ChartAxisConfig v-if="leftAxisSync" v-model="leftAxisSync" :name="$t('dashboard.leftAxis')" />
	<ChartAxisConfig
		v-if="bottomAxisSync"
		v-model="bottomAxisSync"
		:name="$t('dashboard.bottomAxis')"
	/>
	<div class="w-full p-4">
		<SoftSwitch v-model="openDialogOnClickSync" :label="$t('dashboard.openEventDialog')" />
		<SoftSwitch v-model="tooltipSync" :label="$t('dashboard.tooltip')" />
	</div>
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent, PropType } from "vue";
import ChartAxisConfig from "../../config/ChartAxisConfig.vue";
import { defaultEventBarOptions, EventBarOptions } from "./event-bar-options";

export default defineComponent({
	components: { ChartAxisConfig },
	name: "EventBarPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<EventBarOptions>,
			default: () => defaultEventBarOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const axesSync = useRefObjectSync(valueModel, "axes");
		const leftAxisSync = useRefObjectSync(axesSync, "left");
		const bottomAxisSync = useRefObjectSync(axesSync, "bottom");

		const openDialogOnClickSync = useRefObjectSync(valueModel, "openDialogOnClick");
		const tooltipSync = useRefObjectSync(valueModel, "tootlip");

		return { leftAxisSync, bottomAxisSync, openDialogOnClickSync, tooltipSync };
	},
});
</script>
